import React from 'react'
import AppTabPromotionFormPage from './AppTabPromotionFormPage'

export default function NewAppTabPromotion() {
    return <AppTabPromotionFormPage mode="create" />
}
